<div style="width: 100%" class="d-flex flex-column align-items-center justify-content-between">
  <app-admin-header style="width: 100%" [header]="header" [links]="links" [breadcrumbs]="breadcrumbs"
    [queryParams]="queryParams" [stats]="stats"></app-admin-header>
  <p-messages [(value)]="messages" [enableService]="false"></p-messages>
  <div class="w-100">
    <!-- skelition   -->
    <app-skelitions [hidden]="!skelition" [value]="2" class="mb-2"></app-skelitions>
  </div>
  <div id="result-parent" class="container-fluid mb-5 mob-px-5 pt-5 222" *ngIf="!skelition">
    <app-assessment-result-module [hidden]="from != 'assessment'" class="pt-4" [assessmentIds]="[assessmentId]" [totalMarks]="(assessment ) ? assessment.totalMarks : 0"
      (getGradesData)="totalGradesData = $event"></app-assessment-result-module>
    <div class="container">
      <div class="row">
        <h2 class="v4-color-white">{{ (from == 'assessment') ? ("testers information" | translator) : ('testers information Survey' | translator) }}</h2>
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 m-0 p-0">
          <p-tabView class="v4-bg-white ui-tabview v4-dsbrd-btns" [activeIndex]="activeResultTabIndex"
            (onChange)="onTabChange($event)">
            <p-tabPanel *ngIf="assessment != undefined && assessment.accessType == 'BY_ACCOUNT'"
              class="v4-bg-white ui-tabview v4-dsbrd-btns" header="{{ 'Invitees' | translator }}">
              <div *ngIf="showInviteDropdown || isFilterApplied"
                class="d-flex justify-content-center align-items-center gap-2">
                <div class="p-inputgroup my-3">
                  <span class="p-input-icon-right w-100">
                    <i class="pi pi-search"></i>
                    <input type="text" class="p-inputtext-lg sstarabic w-100 radius-8" pInputText
                      placeholder="{{ 'Discus' | translator }}" (keydown.enter)="navigateToSearch($event)"
                      [(ngModel)]="searchText" />
                  </span>
                </div>
                <div class="pppp-drop">
                  <p-dropdown [options]="types" [(ngModel)]="dropType" optionLabel="label" appendTo="body"
                    (onChange)="onChangeDropdown()" [placeholder]="'Select User Type' | translator"></p-dropdown>
                </div>
                <button class="my-3 py-2 v4-btn-every" (click)="resetFilters()">
                  <i class="pi pi-refresh"></i>
                </button>
              </div>
              <app-user-table [data]="filteredInvitees" [loading]="skelition" [messages]="messages"
                [columns]="['the name', 'E-mail', 'Contact', 'Gender']" [action]="0" [goBackBtn]="false" [first]="first"
                [rows]="rows" [pagging]="true" [assessmentId]="assessmentId" [totalCount]="totalInvitees" [from]="from"
                (pageChange)="onPageChange($event,0)" (selectedUsersChange)="handleSelectedUsersChange($event)">
                ></app-user-table>
            </p-tabPanel>
            <p-tabPanel header="{{ 'Results' | translator }}">
              <div *ngIf="showResultDropdown || isFilterApplied"
                class="d-flex justify-content-center align-items-center gap-2">
                <div class="p-inputgroup my-3">
                  <span class="p-input-icon-right w-100">
                    <i class="pi pi-search"></i>
                    <input type="text" class="p-inputtext-lg sstarabic w-100 radius-8" pInputText
                      placeholder="{{ 'Discus' | translator }}" (keydown.enter)="navigateToSearch($event)"
                      [(ngModel)]="searchText" />
                  </span>
                </div>
                <div class="pppp-drop">
                  <p-dropdown [options]="types" [(ngModel)]="dropType" optionLabel="label" appendTo="body"
                    (onChange)="onChangeDropdown()" [placeholder]="'Select User Type' | translator"></p-dropdown>
                </div>
                <button class="my-3 py-2 v4-btn-every" (click)="resetFilters()"><i class="pi pi-refresh"></i></button>
                <button class="my-3 py-2 v4-btn-every" style="background-color:  #dc3545 ;"
                  (click)="deleteUsers()" ><i class="pi pi-trash"></i>
                </button>
                <button *ngIf="!downloadExcel" style="background-color: #217346;" class="my-3 py-2 v4-btn-every"
                  (click)="exportExcel()">
                  <i class="fa-regular fa-file-excel"></i> 
                </button>
                <p-progressSpinner class="v4-spin" *ngIf="downloadExcel" ariaLabel="loading"></p-progressSpinner>
                <button *ngIf="!downloadPdfExcel" [pTooltip]=" 'Download Excel' | translator" style="background-color: grey;" class="my-3 py-2 v4-btn-every"
                  (click)="exportPdfFormatExcel()">
                  <i class="fa-regular fa-file-excel"></i>
                </button>
                <p-progressSpinner class="v4-spin" *ngIf="downloadPdfExcel" ariaLabel="loading"></p-progressSpinner>
                <button *ngIf="!downloadPdf" style="background-color: grey;" class="my-3 py-2 v4-btn-every"
                  (click)="exportPdf()">
                  <i class="fa-regular fa-file-pdf"></i> 
                </button>
                <p-progressSpinner class="v4-spin" *ngIf="downloadPdf" ariaLabel="loading"></p-progressSpinner>
                <button *ngIf="!exportingPPT"  class="my-3 py-2 v4-btn-every" style="background-color: #D24726;"
                  (click)="exportToPPT()"><i class="fa-regular fa-file-powerpoint"></i>
                </button>
                <p-progressSpinner class="v4-spin" *ngIf="exportingPPT" ariaLabel="loading"></p-progressSpinner>
                <button *ngIf="!regenAttempt" [pTooltip]=" 'Regenerate Results' | translator" class="my-3 py-2 v4-btn-every"
                  (click)="regenerateAttempts()"><i class="fa-solid fa-square-poll-vertical"></i>
                </button>
                <p-progressSpinner class="v4-spin" *ngIf="regenAttempt" ariaLabel="loading"></p-progressSpinner>
                <button *ngIf="!sendCert && from == 'assessment'" [pTooltip]=" 'Send Certificate' | translator" class="my-3 py-2 v4-btn-every"
                  (click)="sendCertificate()">
                  <i class="fa-solid fa-certificate"></i>
                </button>
                <p-progressSpinner class="v4-spin" *ngIf="sendCert" ariaLabel="loading"></p-progressSpinner>
                <button class="my-3 py-2 v4-btn-every" (click)="emailModal = true"><i
                    class="pi pi-envelope"></i></button>
              </div>
              <div class="d-flex gap-2">
                <button *ngIf="!downloadExcelCache && cacheCount > 0" style="background-color: #217346;" class="my-3 py-2 v4-btn-every"
                  (click)="exportExcelCache()" >
                  {{ 'Downlaod Cache Attempts' | translator }} {{ ' (' + cacheCount + ')   ' }} <i class="fa-regular fa-file-excel"></i>
                </button>
                <p-progressSpinner class="v4-spin" *ngIf="downloadExcelCache" ariaLabel="loading"></p-progressSpinner>
                <button *ngIf="from == 'assessment' && !downloadCWExcel" style="background-color: #217346;" class="my-3 py-2 v4-btn-every"
                  (click)="exportCorrectWrongExcel()" >
                  {{ 'correct incorrect stats' | translator }} <i class="fa-regular fa-file-excel"></i>
                </button>
                <p-progressSpinner class="v4-spin" *ngIf="downloadCWExcel" ariaLabel="loading"></p-progressSpinner>
              </div>
              <app-user-table [data]="filteredResults" [loading]="skelition" [messages]="messages" [columns]="
                  from == 'assessment'
                    ? [
                        'the name',
                        'E-mail',
                        'Contact',
                        'Gender',
                        'Score / Total Marks',
                        'Percentage',
                        'timeTaken',
                        'submittedTime',
                        'Result'
                      ]
                    : ['the name', 'E-mail', 'Contact', 'Gender']
                " [action]="2" [goBackBtn]="false" [first]="first" [rows]="rows" [pagging]="true"
                [assessmentId]="assessmentId" [totalCount]="totalUserResults" [from]="from"
                (pageChange)="onPageChange($event,1)" (updateDataEvent)="ngOnInit()"
                (selectedUsersChange)="handleSelectedUsersChange($event)">
                ></app-user-table>
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>
    </div>

    <div class="row v4-graph-bg" *ngIf="from != 'assessment'">
      <div class="container">
        <h2 class="v4-color-white">
          {{
          from == "assessment"
          ? ("statistics of each question of the test" | translator)
          : ("statistics of each question of the survey" | translator)
          }}
        </h2>
      </div>
      <app-no-data *ngIf="graphData.length <= 0"></app-no-data>
      <ng-container *ngFor="let data of graphData">
        <div class="col-md-4" style="padding: 5%" *ngIf="!noGraphs.includes(data.questionType)">
          <div *ngIf="data.type">
            <h6 class="text-center v4-color-white">
              {{ data.questionText | translator }}
            </h6>
            <div *ngIf="data.type == 'text'" style="max-height: 420px; overflow-y: auto;">
              <p-table [columns]="data.data.labels" [value]="data.data.datasets[0].data" [scrollable]="true"
                scrollHeight="300px" [tableStyle]="{ 'min-width': '23rem' }">
                <ng-template pTemplate="header" let-columns>
                  <tr style="background: #393a55">
                    <th *ngFor="let col of columns" class="sticky-header">
                      {{ col }}
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr>
                    <ng-container *ngFor="let col of columns; let i = index">
                      <td *ngIf="rowData[i] != '' && rowData[i] != null">
                        {{ rowData[i] }}
                      </td>
                    </ng-container>
                  </tr>
                </ng-template>
              </p-table>
            </div>
            <div *ngIf="data.type == 'bar'">
              <p-chart type="bar" [data]="data.graphData" [options]="barChartOptions" height="400"></p-chart>
            </div>
            <div *ngIf="data.type == 'calander'">
              <table class="w-100">
                <thead>
                  <tr>
                    <th>*</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of data.meta">
                    <td>{{ formatDate(row.value) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <div *ngIf="data.type == 'table'">

                            {{ data.meta[0].fields | json }}
                            <table class="w-100">
                                <thead>
                                <tr>
                                    <th> * </th>
                                    <th *ngFor="let column of data.meta[0].columns">{{ column }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let row of data.meta">
                                    <td>{{row.fields[0].field.label}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div> -->
            <div *ngIf="data.type == 'smile'">
              <div class="row">
                <div class="col-md-12 col-12 my-2">
                  <div class="d-flex flex-row">
                    <div class="rating-bg" *ngFor="let data of data.graphData">
                      <div class="rating-item">
                        <img class="rating-width" src="{{ data.image }}" alt="loading" />
                        <div class="rating-label">
                          {{ data.label | translator }} ({{ data.count }})
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="data.type == 'rate'">
              <div class="row w-100">
                <div class="row w-100" *ngFor="let data of data.graphData">
                  <div class="col-md-12 col-12 my-2">
                    <div class="label-container">
                      <div class="rating-container">
                        <p-rating class="v4-ratting" [disabled]="true" [(ngModel)]="data.value"
                          [cancel]="false"></p-rating>
                      </div>
                      <strong>{{ data.label | translator }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr class="hr" />
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<app-footer></app-footer>
<p-dialog [header]="'Add User to Survey' | translator" [maximizable]="true" [(visible)]="emailModal"
  [style]="{ width: '60vw' }">
  <div class="form-group mt-2">
    <div class="d-flex column label-score mb-2">
      <span class="ans-color v4-color-white">{{ "Email Text" | translator }}</span>
    </div>
    <textarea [(ngModel)]="emailText" [required]="true" class="w-100" [style.height.px]="180">
    </textarea>
  </div>
  <div class="form-group mt-2">
    <div class="d-flex column label-score mb-2">
      <span class="ans-color v4-color-white">{{ "Link" | translator }}</span>
    </div>
    <input type="text" [(ngModel)]="emailLink" class="form-control ms-input">
  </div>
  <div class="mt-4" align="center">
    <button class="v4-btn-every" (click)="sendEmail()">
      <i class="pi pi-check">&nbsp;</i>{{ "Send Mail" | translator }}
    </button>
  </div>
</p-dialog>
<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>